import React from 'react';

/**
 * Subconjunto de la librería de íconos de sistema-licencias-pvc
 * (frontend/src/components/icons/index.jsx): mismos paths, mismo degradé de
 * marca, solo los íconos que usa Caja. Mantenerla alineada si cambia el
 * original.
 */

export const ID_DEGRADE_MARCA = 'degradeMarca';
export const STROKE_DEGRADE = `url(#${ID_DEGRADE_MARCA})`;

const MARCA_DESDE = '#1a9b8e';
const MARCA_HASTA = '#6b2d7f';

const ATRIBUTOS_SVG = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function crearIcono(displayName, contenido) {
  function Icono({ size = 24, stroke = 'currentColor', strokeWidth = 1.8, className = '', ...rest }) {
    const tieneEtiquetaAccesible =
      'aria-label' in rest || 'aria-labelledby' in rest || rest.role === 'img';
    return (
      <svg
        {...ATRIBUTOS_SVG}
        width={size}
        height={size}
        stroke={stroke}
        strokeWidth={strokeWidth}
        className={className}
        {...(tieneEtiquetaAccesible ? null : { 'aria-hidden': 'true' })}
        {...rest}
      >
        {contenido}
      </svg>
    );
  }
  Icono.displayName = displayName;
  return Icono;
}

export function GradienteMarca() {
  return (
    <svg
      width="0"
      height="0"
      aria-hidden="true"
      focusable="false"
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
    >
      <defs>
        <linearGradient id={ID_DEGRADE_MARCA} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={MARCA_DESDE} />
          <stop offset="100%" stopColor={MARCA_HASTA} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export const IconMunicipio = crearIcono(
  'IconMunicipio',
  <>
    <line x1="3" y1="20.5" x2="21" y2="20.5" />
    <polygon points="12 3 20.5 8.5 3.5 8.5" />
    <line x1="5.5" y1="8.5" x2="5.5" y2="20.5" />
    <line x1="9.2" y1="8.5" x2="9.2" y2="20.5" />
    <line x1="14.8" y1="8.5" x2="14.8" y2="20.5" />
    <line x1="18.5" y1="8.5" x2="18.5" y2="20.5" />
  </>
);

export const IconPersona = crearIcono(
  'IconPersona',
  <>
    <circle cx="12" cy="8.3" r="3.8" />
    <path d="M4.5 20.3c0-4.1 3.4-7 7.5-7s7.5 2.9 7.5 7" />
  </>
);

export const IconContrasena = crearIcono(
  'IconContrasena',
  <>
    <circle cx="8.5" cy="8.5" r="4.3" />
    <circle cx="8.5" cy="8.5" r="1.1" />
    <line x1="11.9" y1="11.9" x2="20.5" y2="20.5" />
    <line x1="15.5" y1="16.2" x2="18" y2="13.7" />
    <line x1="18.2" y1="18.8" x2="20.2" y2="16.8" />
  </>
);

export const IconMostrarContrasena = crearIcono(
  'IconMostrarContrasena',
  <>
    <path d="M2.3 12S5.8 5.5 12 5.5 21.7 12 21.7 12 18.2 18.5 12 18.5 2.3 12 2.3 12z" />
    <circle cx="12" cy="12" r="3.1" />
  </>
);

export const IconOcultarContrasena = crearIcono(
  'IconOcultarContrasena',
  <>
    <path d="M2.3 12S5.8 5.5 12 5.5 21.7 12 21.7 12 18.2 18.5 12 18.5 2.3 12 2.3 12z" />
    <circle cx="12" cy="12" r="3.1" />
    <line x1="3.5" y1="20.5" x2="20.5" y2="3.5" />
  </>
);

export const IconExito = crearIcono('IconExito', <polyline points="4.5 12.5 9.5 17.5 19.5 6.5" />);

export const IconAdvertencia = crearIcono(
  'IconAdvertencia',
  <>
    <path d="M12 3.5 21.5 20H2.5L12 3.5z" />
    <line x1="12" y1="10" x2="12" y2="14.3" />
    <circle cx="12" cy="17" r="0.15" strokeWidth="2.6" />
  </>
);

export const IconCandado = crearIcono(
  'IconCandado',
  <>
    <rect x="5" y="10.5" width="14" height="10" rx="1.8" />
    <path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" />
    <circle cx="12" cy="15" r="1.4" />
  </>
);

export const IconDocumento = crearIcono(
  'IconDocumento',
  <>
    <path d="M6.5 3h8l4 4v13.5a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
    <polyline points="14.5 3 14.5 7 18.5 7" />
    <line x1="8.5" y1="12" x2="15.5" y2="12" />
    <line x1="8.5" y1="15.5" x2="13" y2="15.5" />
  </>
);

/* Sin equivalente en sistema-licencias-pvc (no maneja dinero): ícono nuevo,
   mismas convenciones de trazo/viewBox que el resto de la librería. */
export const IconDinero = crearIcono(
  'IconDinero',
  <>
    <rect x="2.5" y="6" width="19" height="12" rx="2.2" />
    <circle cx="12" cy="12" r="2.6" />
    <line x1="5.5" y1="9" x2="5.5" y2="9.01" />
    <line x1="18.5" y1="15" x2="18.5" y2="15.01" />
  </>
);

/* Copiados de sistema-licencias-pvc (components/icons/index.jsx) */

export const IconAgregar = crearIcono(
  'IconAgregar',
  <>
    <line x1="12" y1="4.5" x2="12" y2="19.5" />
    <line x1="4.5" y1="12" x2="19.5" y2="12" />
  </>
);

export const IconImprimir = crearIcono(
  'IconImprimir',
  <>
    <rect x="6" y="3.5" width="12" height="6" rx="0.8" />
    <path d="M6 15.5H4.2A1.7 1.7 0 0 1 2.5 13.8V9.9A1.7 1.7 0 0 1 4.2 8.2h15.6a1.7 1.7 0 0 1 1.7 1.7v3.9a1.7 1.7 0 0 1-1.7 1.7H18" />
    <rect x="6" y="13" width="12" height="7.5" rx="0.6" />
  </>
);

export const IconRechazar = crearIcono(
  'IconRechazar',
  <>
    <circle cx="12" cy="12" r="8.7" />
    <line x1="8.5" y1="8.5" x2="15.5" y2="15.5" />
    <line x1="15.5" y1="8.5" x2="8.5" y2="15.5" />
  </>
);
